module.exports = __webpack_public_path__ + "statics/img/3-7.b5ed473.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/3-7.png
// module id = YNr9
// module chunks = 1